import { render, staticRenderFns } from "./ReportHeaderPage.vue?vue&type=template&id=b7743cbe&scoped=true"
import script from "./ReportHeaderPage.vue?vue&type=script&lang=js"
export * from "./ReportHeaderPage.vue?vue&type=script&lang=js"
import style0 from "./ReportHeaderPage.vue?vue&type=style&index=0&id=b7743cbe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7743cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7743cbe')) {
      api.createRecord('b7743cbe', component.options)
    } else {
      api.reload('b7743cbe', component.options)
    }
    module.hot.accept("./ReportHeaderPage.vue?vue&type=template&id=b7743cbe&scoped=true", function () {
      api.rerender('b7743cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/ReportHeaderPage.vue"
export default component.exports